export interface HostAuthConfiguration {
  clientId?: string;
}

export type HostAuthConfigurations = Record<string, HostAuthConfiguration>;

export const hostAuthConfigurations: HostAuthConfigurations = {
  localhost: {
    clientId: import.meta.env.VITE_CLIENT_ID_LOCALHOST,
  },
  'shell-pre-areaprivada.globalsyde.com': {
    clientId: import.meta.env.VITE_CLIENT_ID_SHELL_PRE,
  },
  'shell-atlas.globalsyde.com': {
    clientId: import.meta.env.VITE_CLIENT_ID_SHELL,
    },
  'energreen-atlas.globalsyde.com': {
    clientId: import.meta.env.VITE_CLIENT_ID_ENERGREEN,
  },
  'luzy-atlas.globalsyde.com': {
    clientId: import.meta.env.VITE_CLIENT_ID_LUZY,
  },
  'test-atlas.globalsyde.com': {
    clientId: import.meta.env.VITE_CLIENT_ID_TEST,
  },
};

export function resolveHostAuthConfiguration(
  hostname: string,
  configurations: HostAuthConfigurations = hostAuthConfigurations,
): Required<HostAuthConfiguration> {
  const configuration = configurations[hostname];

  if (!configuration) {
    throw new Error(`No External ID application is registered for host '${hostname}'.`);
  }

  const clientId = configuration.clientId?.trim();
  if (!clientId) {
    throw new Error(`External ID client ID is not configured for host '${hostname}'.`);
  }

  if (!isGuid(clientId)) {
    throw new Error(`External ID client ID for host '${hostname}' is not a valid GUID.`);
  }

  return { clientId };
}

function isGuid(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
}
